var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-data-container" }, [
    _c("div", { staticClass: "content-container" }, [
      _c("div", { staticClass: "text-container" }, [
        _vm._v(" " + _vm._s(_vm.noDataText) + " ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }